<template>
    <div class="collection-controls" :class="{ 'list': !isExpanded }">

        <button @click="toggle('iso')" type="button"
                :class="{ active: iso }" class="btn btn-outline-secondary me-1 collection-toggle coll-iso">
            <i class="fa-regular fa-magnifying-glass-plus d-none d-sm-inline d-md-none d-xl-inline"></i> ISO
        </button>
        <button v-if="isExpanded" @click="toggle('grail')" type="button"
                :class="{ active: grail }" class="btn btn-outline-secondary me-4 collection-toggle coll-grail">
            <i class="fa-regular fa-crown d-none d-sm-inline d-lg-none d-xl-inline"></i> GRAIL
        </button>
        <button @click="toggle('own')" type="button"
                :class="{ active: own }" class="btn btn-outline-secondary me-1 collection-toggle coll-own">
            <i class="fa-regular fa-circle-check d-none d-sm-inline"></i> OWN
        </button>
        <button @click="toggle('trade')" type="button"
                :class="{ active: trade }" class="btn btn-outline-secondary collection-toggle coll-trade">
            <i class="fa-regular fa-right-left d-none d-sm-inline"></i> TRADE</button>

    </div>
</template>

<script>
    export default {
        name: "CollectionControls",
        props: {
            isExpanded: {
                type: Boolean,
                required: false,
                default: false
            }, 
            item: {
                type: String,
                required: true
            }, 
            itemId: {
                type: Number,
                required: true
            },
            collection: {
                type: Object,
                required: false,
                default: {own: false, iso: false, trade: false, grail: false}
            }
        },
        data() {
            return {
                own: this.collection.own,
                iso: this.collection.iso,
                trade: this.collection.trade,
                grail: this.collection.grail
            }
        },
        methods: {
            
            toggle: function(collectionCategory) {
                if (this[collectionCategory]) {
                    // if (collectionCategory === 'own') {
                    //     axios.delete('/collections/'+this.own);
                    //     if (this.trade) {
                    //         axios.delete('/lists/trade/item/' + this.trade);
                    //         this.trade = false;
                    //     }
                    // } else {
                    //     axios.delete('/lists/' + collectionCategory + '/item/' + this[collectionCategory]);
                    // }
                    axios.delete('/collections/'+collectionCategory+'/'+this[collectionCategory]);
                    
                    this[collectionCategory] = false;
                    if (collectionCategory === 'own') {
                        this.trade = false;
                    }
                } else {
                    // if (collectionCategory === 'own') {
                    //     this.addToCollection();
                    // } else if (collectionCategory === 'trade' && !this.own) {
                    //     this.addToCollection(collectionCategory);
                    // } else {
                    //     this.addToList(collectionCategory);
                    // }
                    this.addToCollection(collectionCategory);
                }
            },

            addToCollection: function(collectionCategory = false) {
                axios.post('/collections', {
                            itemId: this.itemId,
                            item: this.item,
                            collection: collectionCategory
                        }).then(response => {
                            if (collectionCategory === 'own') {
                                this.own = response.data.id;
                            } else if (collectionCategory === 'trade' && !this.own) {
                                this.own = response.data.id;
                                this[collectionCategory] = response.data.id;
                            } else {
                                this[collectionCategory] = response.data.id;
                            }
                            
                            // if (collectionCategory) {
                            //     this.addToList(collectionCategory);
                            // }
                        }).catch(error => {
                            //
                        });
            },

            // addToList: function(collectionCategory) {
            //     axios.post('/lists/' + collectionCategory + '/item', {
            //                 itemId: collectionCategory === 'trade' ? this.own : this.itemId,
            //                 item: this.item
            //             }).then(response => {
            //                 this[collectionCategory] = response.data.id;
            //             }).catch(error => {
            //                 //
            //             });
            // }
        }
    }
</script>